import { action } from 'satcheljs';

/**
 * Called when there is a change in the forward meeting notification option
 */

let selectForwardMeetingNotificationOption = action(
    'selectForwardMeetingNotificationOption',
    (removeForwardedMeetingNotifications: boolean) => ({
        removeForwardedMeetingNotifications,
    })
);

export default selectForwardMeetingNotificationOption;
